<div class="container">
  <div class="close-icon">
    <div class="main_title">System Documentation</div>
    <i class="mdi mdi-close" (click)="closeHelpMenu()"></i>
  </div>
  <ng-container *ngFor="let menuItem of helpMenuDataSource">
    <div class="document-section" *ngIf="isVisibleSubMenu(menuItem)">
      <div class="section title">{{ menuItem.section }}</div>
      <div *ngFor="let list of menuItem.documents">
        <div class="list-container" (click)="openDocument(list)">
          <div class="document-icon">
            <i class="mdi mdi-file-pdf-box icon" *ngIf="list.type === 'pdf'"></i>
            <i class="mdi mdi-certificate icon" *ngIf="list.type === 'certificate'"></i>
            <i class="mdi mdi-file-excel icon" *ngIf="list.type === 'xlsx'"></i>
            <i class="mdi mdi-file-document icon" *ngIf="list.type === 'document'"></i>
          </div>
          <div class="document-details">
            <div class="title">{{ list.title }}</div>
            <div class="version" *ngIf="list.version">{{ list.version }}</div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
